import { useRouter } from 'next/router';
import { env } from '@zopauk/nextjs-env';
import { logEvent } from '@/utils/analytics';
import amplitudeEvents from '@/utils/amplitudeEvents.json';
import { MarkdownToJSX } from '@/components/MarkdownToJSX';

type ChatCardProps = {
  description?: string;
  title: string;
};

export const ChatCard = ({ description, title }: ChatCardProps) => {
  const { replace, asPath } = useRouter();

  return (
    <button
      className="cursor-pointer w-full hover:scale-[1.01] transition-all relative border border-base-400 max-w-[768px] focus-within:ring-offset-background focus-within:ring-focused focus-within:ring-2 focus-within:ring-offset-2 rounded-lg text-left pt-6 flex px-6 mx-auto mb-5 md:mb-6 bg-[#ffffff]"
      onClick={() => {
        logEvent(amplitudeEvents.START_CHAT, {
          id: 'chat-started-click',
          page: asPath,
        });
        replace(env('NEXT_PUBLIC_APPSFLYER_CHAT_URL') || '');
      }}
      data-automation="ZA.button-chat-card"
      type="button"
    >
      <div className="mr-5">
        <span className="material-symbols-outlined text-5xl!">sms</span>
      </div>
      <div>
        {title ? <span className="mb-2 font-serif block text-xl">{title}</span> : null}
        {description ? <MarkdownToJSX md={description} /> : null}
      </div>
    </button>
  );
};
